import { render, staticRenderFns } from "./PopUpGeneratedReports.vue?vue&type=template&id=0446e08a&"
import script from "./PopUpGeneratedReports.vue?vue&type=script&lang=ts&"
export * from "./PopUpGeneratedReports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0446e08a', component.options)
    } else {
      api.reload('0446e08a', component.options)
    }
    module.hot.accept("./PopUpGeneratedReports.vue?vue&type=template&id=0446e08a&", function () {
      api.rerender('0446e08a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Atenciones/PopUpGeneratedReports.vue"
export default component.exports